// src/components/atoms/LoadingAndError.tsx

import React from "react";
import { Box, CircularProgress, Alert, Button } from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';

interface LoadingSpinnerProps {
  minHeight?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  minHeight = "100vh"  // デフォルト値を設定
}) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight={minHeight}
    >
      <CircularProgress />
    </Box>
  );
};

interface ErrorWithRetryProps {
  onRetry: () => void;
  errorMessage?: string;
  minHeight?: string;
}

export const ErrorWithRetry: React.FC<ErrorWithRetryProps> = ({
  onRetry,
  errorMessage = "データの読み込みに失敗しました",  // デフォルトのエラーメッセージ
  minHeight = "100vh"  // デフォルト値を設定
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight={minHeight}
      gap={2}
    >
      <Alert severity="error">{errorMessage}</Alert>
      <Button
        startIcon={<RefreshIcon />}
        variant="contained"
        onClick={onRetry}
      >
        再読み込み
      </Button>
    </Box>
  );
};